<template>
    <div class="reports">
        <h2 class="reports__title">{{ getTranslatedText('Reports') }}</h2>
        <v-tabs v-model="tab" @change="onTabChanged">
            <v-tab href="#tab-1">{{ getTranslatedText('Daily') }}</v-tab>
            <v-tab href="#tab-2">{{ getTranslatedText('Weekly') }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
                <Reports ref="report1" type="daily" />
            </v-tab-item>
            <v-tab-item value="tab-2">
                <Reports ref="report2" type="weekly" />
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import Reports from '@/components/report-info'

export default {
    mixins: [languageMixins],
    components: { Reports },
    data() {
        return {
            tab: null,
        }
    },
    methods: {
        // TODO: recheck @Thanh
        onTabChanged() {
            let reportComponent;
            if (this.tab === 'tab-1') {
                reportComponent = this.$refs.report1;
            } else if (this.tab === 'tab-2') {
                reportComponent = this.$refs.report2;
            }
            if (reportComponent) reportComponent.fetchDataReports()
        },
    }
}
</script>
<style lang="scss">
@import '~ThemePath/scss/reports/_index.scss';
</style>
